var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupCallAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 10,
    fill: "url(#paint0_linear_5461_4833)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.59 17.4103C15 17.8003 15 18.4403 14.59 18.8303C14.2 19.2203 13.56 19.2203 13.17 18.8303C11.22 16.8803 11.22 13.7103 13.17 11.7603L16.71 8.22031C18.66 6.27031 21.83 6.27031 23.78 8.22031C25.73 10.1703 25.73 13.3403 23.78 15.2903L22.29 16.7803C22.3 15.9603 22.17 15.1403 21.89 14.3603L22.36 13.8803C23.54 12.7103 23.54 10.8103 22.36 9.64031C21.19 8.46031 19.29 8.46031 18.12 9.64031L14.59 13.1703C13.41 14.3403 13.41 16.2403 14.59 17.4103ZM17.41 13.1703C17.8 12.7803 18.44 12.7803 18.83 13.1703C20.78 15.1203 20.78 18.2903 18.83 20.2403L15.29 23.7803C13.34 25.7303 10.17 25.7303 8.22001 23.7803C6.27001 21.8303 6.27001 18.6603 8.22001 16.7103L9.71001 15.2203C9.70001 16.0403 9.83001 16.8603 10.11 17.6503L9.64001 18.1203C8.46001 19.2903 8.46001 21.1903 9.64001 22.3603C10.81 23.5403 12.71 23.5403 13.88 22.3603L17.41 18.8303C18.59 17.6603 18.59 15.7603 17.41 14.5903C17 14.2003 17 13.5603 17.41 13.1703Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5461_4833",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC92ED",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC92ED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupCallAvatar);
export default __webpack_public_path__ + "static/media/group_call_avatar.7af11f5b54a959bf36f6035499c437a5.svg";
export { ForwardRef as ReactComponent };